import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Tabs from "../../components/tabs/Tabs";
import { useUser } from "../../hooks/useUser";
import PageHeader from "../../components/ui/PageHeader";
import { HOME_CRUMB } from "../../components/ui/Breadcrumbs";

const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [initialTab, setInitialTab] = useState<string | null>(null);
  const { fetchProfile } = useUser();

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      setInitialTab(tabParam);
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col w-full">
      <div className="flex-1 w-full max-w-full py-2 overflow-x-hidden sm:p-6">
        {/* Header */}
        <PageHeader
          breadcrumbs={[HOME_CRUMB, { label: "Settings" }]}
          className="mb-4"
          title="Settings"
          description="Your profile, account, and connected services."
        />

        {/* Tabs */}
        <Tabs
          initialTab={initialTab}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>
    </div>
  );
};

export default Settings;